import { sortBy } from 'lodash-es';

const sortFacets = facets => {
  return sortBy(facets, ['config.indexInsideGroup']).map(facet =>
    facet.group ? { ...facet, values: sortFacets(facet.values) } : facet
  );
};

export const sortFacetsInGroups = groups => {
  return sortBy(
    groups.map(group => {
      return { ...group, facets: sortFacets(group.facets) };
    }),
    ['order']
  );
};
